﻿"use strict";
import 'owl.carousel';

var MostReadBlogs = function() {

    return {
        init: function() {

            var carousels = $("[data-owl='most-read']");
            var carouselResponsiveOptions1 = {
                stagePadding: 32,
                loop: true,
                margin: 16,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 2
                    },
                    900: {
                        items: 3,
                        stagePadding: 32,
                        margin: 32
                    },
                    1200: {
                        loop: false,
                        items: 4,
                        stagePadding: 0,
                        margin: 32
                    }
                }
            };

            if (carousels.length) {

                carousels.owlCarousel(carouselResponsiveOptions1);
            }
        }
    };

};

document.addEventListener("DOMContentLoaded", function () {
    const mostReadBlogs = new MostReadBlogs();
    mostReadBlogs.init();
});